import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

export const homeFor = (u) => (u?.role === 'admin' ? '/admin' : u?.role === 'learner' ? '/account' : u?.role === 'student' ? '/student' : '/teacher');

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const setSession = (data) => {
    if (data?.access_token) localStorage.setItem('access_token', data.access_token);
    if (data?.refresh_token) localStorage.setItem('refresh_token', data.refresh_token);
    if (data?.user) {
      localStorage.setItem('user', JSON.stringify(data.user));
      setUser(data.user);
    }
  };

  const login = async (identifier, password) => {
    const { data } = await api.post('/auth/login', { identifier, password });
    if (data.unverified) return data;
    setSession(data);
    return data;
  };

  const loginOtp = async (mobile, code) => {
    const { data } = await api.post('/account/login/otp', { mobile, code });
    setSession(data);
    return data;
  };

  const studentLogin = async (username, password) => {
    const { data } = await api.post('/student/login', { username, password });
    setSession(data);
    return data;
  };

  const registerLearner = async (payload) => {
    const { data } = await api.post('/account/register', payload);
    setSession(data);
    return data;
  };

  const adminLogin = async (identifier, password) => {
    const { data } = await api.post('/admin/login', { identifier, password });
    setSession(data);
    return data;
  };

  const logout = async () => {
    try {
      const rt = localStorage.getItem('refresh_token');
      if (rt) await api.post('/auth/logout', { refresh_token: rt });
    } catch (_e) { /* ignore */ }
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const stored = JSON.parse(localStorage.getItem('user') || 'null');
      const path = stored?.role === 'learner' ? '/account/me' : stored?.role === 'student' ? '/student/me' : '/teacher/me';
      const { data } = await api.get(path);
      localStorage.setItem('user', JSON.stringify(data.user));
      setUser(data.user);
      return data;
    } catch (_e) { return null; }
  };

  return (
    <AuthCtx.Provider value={{ user, setUser: (u) => { localStorage.setItem('user', JSON.stringify(u)); setUser(u); }, setSession, login, loginOtp, studentLogin, registerLearner, adminLogin, logout, refreshUser, loading, setLoading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
